__turbopack_context__.v({
  "ownerFilter": "FoldersHeader-module__Hxs64G__ownerFilter",
  "root": "FoldersHeader-module__Hxs64G__root",
  "sharing": "FoldersHeader-module__Hxs64G__sharing",
});
